/**
 * Avatar — DS Atom
 */

import styles from './Avatar.module.css';

interface AvatarProps {
  name?: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  status?: 'online' | 'offline' | 'away';
  className?: string;
}

function getInitials(name: string): string {
  return name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
}

export function Avatar({ name = '', src, size = 'md', status, className = '' }: AvatarProps) {
  return (
    <div className={`${styles.wrapper} ${styles[size]} ${className}`}>
      {src ? (
        <img className={styles.img} src={src} alt={name} />
      ) : (
        <div className={styles.initials}>{getInitials(name)}</div>
      )}
      {status && <div className={`${styles.status} ${styles[status]}`} />}
    </div>
  );
}
